<template>
	<div>
		<span class="filter-txt">选择分公司</span>
		<el-select @change="chooseChildCompany" size="medium" v-model="childChoose" :placeholder="tip">
			<el-option label="请选择分公司"></el-option>
			<el-option v-for="(item,key) in childCompany" :key="key" :label="item.com_name" :value="item.com_id"></el-option>
		</el-select>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				childChoose: '',
				tip:'请选择分公司',
			}
		},
		props: {
			childCompany: {
				type: Array,
				default: () => ([])
			}
		},
		methods: {
			chooseChildCompany(val) {
				this.$emit('choose', val)
			}
		},
		computed:{
			isChanged(a,b){
				return this.$store.state.common.biaotouName
			}
		},
		watch: {
			isChanged(a,b){
				if(this.$store.state.common.biaotouName){
					this.childChoose = ''
				}
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/globle/childCom.vue